import ApiClient from "./ApiClient";

export const getInternational = ({ id, matches_page = 1, matches_per_page = 10 }) =>
  ApiClient.get(`/players/${id}`, {
    params: { matches_page: matches_page, matches_per_page: matches_per_page }
  });
